import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Description,
  GridContainer,
  GridSection,
  Title,
} from "../components/CommonComponents";
import GridArrow from "../components/GridArrow";
import PriceCard from "../components/PriceCard";
import PriceCarousel from "../components/PriceCarousel";
import { CrossEllipse } from "../components/svgs";
import backgound_image from "../images/background4.jpg";
import { width_detector } from "../utills/utills";

const Image = styled.div`
  max-width: 100vw;
  position: relative;
  top: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    transform: scale(0.8);
  }
`;
const Text = styled.div`
position: absolute;
font-weight: 600;
& h1{
  font-size: 2rem;
}
`;
const Align = styled.div`
  position: relative;
  top: 20%;
  padding: 0px 10%;
  @media (max-width: 1024px) {
    top: 25%;
  }
  @media (max-width: 768px) {
    top: 30%;
  }
`;

function Price() {
  const [isOverflow, setIsOverflow] = useState(false);
  useEffect(() => {
    setIsOverflow(width_detector());
    window.addEventListener("resize", () => setIsOverflow(width_detector()));
    return window.addEventListener("resize", () =>
      setIsOverflow(width_detector())
    );
  }, [isOverflow, setIsOverflow]);

  return (
    <GridContainer id="price" img={backgound_image} className='page-container'>
      <GridArrow next_page="contact"/>
      <GridSection>
        <Align>
          <Title>The Right Solution for You.</Title>
          <Description>
            We provide the optimal solution at a reasonable price.
          </Description>
        </Align>
        <Image>
          <CrossEllipse />
          <Text>
            <span>Each Device</span>
            <h1>$ 1000</h1>
          </Text>
        </Image>
      </GridSection>
      <GridSection>
        {isOverflow ? <PriceCard /> : <PriceCarousel />}
      </GridSection>
    </GridContainer>
  );
}

export default Price;
